import { gql } from "@apollo/client";

/**
 * GraphQL Query - Infrastructure layer
 * Fetches the global organizations and brands lookup (count + items).
 */
export const GET_ORGANIZATIONS_BRANDS_LOOKUP = gql`
  query OrganizationsBrandsLookup {
    organizationsBrandsLookup {
      count
      items {
        organizationId
        organizationKey
        organizationName
        organizationDisplayName
        organizationDescription
        organizationLogoUrl
        organizationIsActive

        brands {
          brandId
          brandKey
          brandName
          brandDisplayName
          brandDescription
          brandLogoUrl
          brandIsActive
          brandFeaturesCount
        }
      }
    }
  }
`;
